<template>
  <div class="flex flex-col gap-2 px-4 py-2">
    <div
      v-for="i in count"
      :key="i"
      class="flex items-start gap-3 rounded-lg border border-border bg-card/30 p-3"
    >
      <Skeleton class="h-9 w-9 rounded-full" />
      <div class="flex-1 space-y-2">
        <Skeleton class="h-3.5 w-3/4" />
        <Skeleton class="h-3 w-full" />
        <Skeleton class="h-3 w-2/3" />
      </div>
      <Skeleton class="h-3 w-10" />
    </div>
  </div>
</template>

<script setup>
import { Skeleton } from "@/shared/ui/skeleton";

defineProps({
  count: { type: Number, default: 5 },
});
</script>
